import { Button, Icons } from "@win-reality/react-ui";
import { useNavigate } from "react-router-dom";

import { ROUTES } from "@/lib/routes";

import { LiveEventLockedAlert } from "../LiveEventLockedAlert/LiveEventLockedAlert";

type LiveEventLockedConfigurationProps = {
  complexName: string;
  fieldId: string;
};

function LiveEventLockedConfiguration({
  complexName,
  fieldId,
}: LiveEventLockedConfigurationProps) {
  const navigate = useNavigate();

  const handleNavigate = () => {
    const path = ROUTES.MANAGE_FIELD.replace(
      ":complexName",
      complexName,
    ).replace(":fieldId", fieldId);
    navigate(`${path}?tab=configuration`);
  };

  return (
    <div>
      <LiveEventLockedAlert />

      <div className="flex flex-col items-center justify-center pt-24 gap-4 text-center">
        <Icons.Padlock className="size-12" />
        <div className="text-lg font-bold">Active Event</div>
        <p className="text-sm text-gray-600 max-w-xs">
          Event details cannot be changed after the event has started. To modify
          the strike zone and LED board settings, access your field
          configurations.
        </p>
        <Button variant="secondary-flat-light" onClick={handleNavigate}>
          Field Configurations
        </Button>
      </div>
    </div>
  );
}

export { LiveEventLockedConfiguration };
